module.exports = __webpack_public_path__ + "img/create-post-doc-example.e73edfad.png";